var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescriptionCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8187 2.95064H22.1155V1.94471C22.1155 1.61539 21.8517 1.33398 21.5063 1.33398H11.4187C11.0732 1.33398 10.8094 1.6154 10.8094 1.94471V2.95064H5.10623C4.76706 2.95064 4.46558 3.22008 4.46558 3.54943V30.0566C4.46558 30.3859 4.76707 30.6673 5.11255 30.6673H27.8186C28.1641 30.6673 28.4656 30.3859 28.4656 30.0566V3.54943C28.4593 3.22011 28.1578 2.95064 27.8186 2.95064H27.8187ZM12.0659 3.54943V2.53151H20.8591V4.56734H12.0659V3.54943ZM27.2031 29.4758H5.72196V4.14778H10.8096V5.15371C10.8096 5.48303 11.0735 5.76444 11.4189 5.76444H21.5065C21.852 5.76444 22.1158 5.48302 22.1158 5.15371V4.14778H27.2034L27.2031 29.4758Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67428 12.591H12.066C12.4115 12.591 12.6942 12.3216 12.6942 11.9923V8.75895C12.6942 8.42963 12.4115 8.16016 12.066 8.16016H8.67428C8.32882 8.16016 8.04614 8.4296 8.04614 8.75895V11.9923C8.04614 12.3216 8.32879 12.591 8.67428 12.591ZM9.30241 9.35774H11.438V11.3337H9.30241V9.35774Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9941 8.75895C14.9941 9.08827 15.2768 9.35774 15.6223 9.35774H24.0325C24.3779 9.35774 24.6606 9.0883 24.6606 8.75895C24.6606 8.4296 24.3779 8.16016 24.0325 8.16016H15.6223C15.2768 8.16016 14.9941 8.4296 14.9941 8.75895Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8243 12.5316C20.1698 12.5316 20.4525 12.2621 20.4525 11.9328C20.4525 11.6034 20.1698 11.334 19.8243 11.334H15.6223C15.2768 11.334 14.9941 11.6034 14.9941 11.9328C14.9941 12.2621 15.2768 12.5316 15.6223 12.5316H19.8243Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7797 23.8474H16.3301L15.6077 21.0931C15.5387 20.8416 15.3125 20.662 15.0424 20.644C14.7724 20.6261 14.5148 20.7758 14.4143 21.0213L12.643 25.2246L12.241 23.5181C12.1782 23.2427 11.9207 23.057 11.6255 23.057H8.67965C8.33419 23.057 8.05151 23.3265 8.05151 23.6558C8.05151 23.9852 8.33416 24.2546 8.67965 24.2546H11.123L11.8516 27.3921C11.9144 27.6496 12.1406 27.8352 12.4169 27.8532H12.4672C12.7247 27.8532 12.9571 27.7035 13.0513 27.476L14.854 23.1828L15.2246 24.5899C15.2937 24.8593 15.5449 25.039 15.8338 25.039H18.7797C19.1251 25.039 19.4078 24.7695 19.4078 24.4402C19.4078 24.1108 19.1252 23.8474 18.7797 23.8474H18.7797Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.032 14.627H8.68746C8.342 14.627 8.05933 14.8964 8.05933 15.2257C8.05933 15.5551 8.34198 15.8245 8.68746 15.8245H24.032C24.3774 15.8245 24.6601 15.5551 24.6601 15.2257C24.6601 14.8964 24.3774 14.627 24.032 14.627Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.032 17.8594H8.68746C8.342 17.8594 8.05933 18.1288 8.05933 18.4582C8.05933 18.7875 8.34198 19.057 8.68746 19.057H24.032C24.3774 19.057 24.6601 18.7875 24.6601 18.4582C24.6601 18.1288 24.3774 17.8594 24.032 17.8594Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0314 26.6621H20.2502C19.9047 26.6621 19.6221 26.9316 19.6221 27.2609C19.6221 27.5902 19.9047 27.8597 20.2502 27.8597H24.0314C24.3769 27.8597 24.6596 27.5902 24.6596 27.2609C24.6596 26.9316 24.3769 26.6621 24.0314 26.6621Z",
    fill: "#04B7B1",
    stroke: "#04B7B1",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionCard);
export default __webpack_public_path__ + "static/media/DescriptionCard.6394f2bb66a90a4dcf3d5f2c61a8b4f6.svg";
export { ForwardRef as ReactComponent };